/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { lazy, Suspense } from 'react';
import MainLayout from 'layouts/MainLayout';
import { AuthProvider } from 'context/AuthContext';
import { Outlet, RouteObject, createBrowserRouter } from 'react-router-dom';
import MainLayoutProvider from 'providers/MainLayoutProvider';
import App from 'App';
import Protected from 'components/auth/Protected';
import { autoLoginLoader } from 'loaders/autoLoginLoader';
import { autoLogoutLoader } from 'loaders/autoLogoutLoader';
import IntroWrapper from 'pages/intro/IntroWrapper';

import paymentsRoutes from 'routes/paymentsRoutes';
import hrmsRoutes from 'routes/hrmsRoutes';
import vendorRoutes from 'routes/vendorRoutes';
import vehicleRoutes from 'routes/vehicleRoutes';
import { vehicleUpdateLocation } from 'loaders/vehicleUpdateLocation';
import Dashboard from 'pages/dashboard/Dashboard';
import CheckManualPunch from 'pages/check/manual-punch/CheckManualPunch';
import EmployeeLatePunchinApproval from 'pages/approvals/employee-late-punchin-approval/EmployeeLatePunchinApproval';
import InventoryItemsList from 'pages/Inventory/Inventory-Items/InventoryItemsList';
import InventoryCategoriesList from 'pages/Inventory/Inventory-Categories/InventoryCategoriesList';
import InventoryReportsList from 'pages/Inventory/Inventory-Reports/InventoryReportsList';
import InventoryDashboard from 'pages/Inventory/Inventory-Dashboard/InventoryDashboard';

import SettingNav from 'pages/settings/SettingNav';
import SalesDashboard from 'pages/dashboard/SalesDashboard';

const HomePage = lazy(() => import('pages/HomePage'));
const CardSignIn = lazy(() => import('pages/authentication/login/SignIn'));
const VehicleList = lazy(
  () => import('pages/vehicle/vehicle-list/VehicleList')
);
const DriverApproval = lazy(
  () => import('pages/approvals/driver-approval/DriverApproval')
);
const VehicleApproval = lazy(
  () => import('pages/approvals/vehicle-approval/VehicleApproval')
);
const CustomerList = lazy(
  () => import('pages/customer/customer-list/CustomerList')
);
const Branch = lazy(() => import('pages/location/branch/Branch'));
const Location = lazy(() => import('pages/location/location/Location'));
const Route = lazy(() => import('pages/location/route/Route'));
const CustomerApproval = lazy(
  () => import('pages/approvals/customer-approval/CustomerApproval')
);
const LocationApproval = lazy(
  () => import('pages/approvals/location-approval/LocationApproval')
);
const BranchApproval = lazy(
  () => import('pages/approvals/branch-approval/BranchApproval')
);
const RouteApproval = lazy(
  () => import('pages/approvals/route-approval/RouteApproval')
);
const SettingLayout = lazy(() => import('layouts/SettingLayout'));
const Settings = lazy(() => import('pages/settings/Settings'));
const ComingSoon = lazy(() => import('pages/ComingSoon'));
const HrmsDashboard = lazy(() => import('pages/dashboard/HrmsDashboard'));
const DoList = lazy(() => import('pages/operations/do/do-list/DoList'));
const PoList = lazy(() => import('pages/operations/po/po-list/PoList'));
const PermitList = lazy(
  () => import('pages/operations/permit/permit-list/PermitList')
);
const EmployeeApproval = lazy(
  () => import('pages/approvals/employee-approval/EmplyeeApproval')
);
const RunningTrip = lazy(() => import('pages/trip/RunningTrip'));
const BreakdownTrips = lazy(() => import('pages/trip/BreakdownTrips'));
const CompletedTrips = lazy(() => import('pages/trip/CompletedTrips'));
const GeneralError = lazy(() => import('pages/error/GeneralError'));
const CreateVehiclePage = lazy(() => import('pages/vehicle/CreateVehiclePage'));
const CreateCustomer = lazy(() => import('pages/customer/CreateCustomer'));

const CreateDO = lazy(() => import('pages/operations/do/CreateDO'));
const CreatePO = lazy(() => import('pages/operations/po/CreatePO'));
const CreatePermit = lazy(() => import('pages/operations/permit/CreatePermit'));
const CreateChallan = lazy(
  () => import('pages/operations/challan/CreateChallan')
);
const FuelRetailerApproval = lazy(
  () =>
    import('pages/approvals/vendor-approval/FuelRetailer/FuelRetailerApproval')
);
const RegularApproval = lazy(
  () => import('pages/approvals/vendor-approval/Regularvendor/RegularApproval')
);
const TruckerApproval = lazy(
  () => import('pages/approvals/vendor-approval/Trucker/TruckerApproval')
);
const LeaveApproval = lazy(
  () => import('pages/approvals/leave-approval/LeaveApproval')
);
const DoApproval = lazy(() => import('pages/approvals/do-approval/DoApproval'));
const PoApproval = lazy(() => import('pages/approvals/po-approval/PoApproval'));
const PermitApprovalHistory = lazy(
  () => import('pages/approvals/permit-approval/PermitApprovalHistory')
);
const PermitApproval = lazy(
  () => import('pages/approvals/permit-approval/PermitApproval')
);
const DesignationApproval = lazy(
  () => import('pages/approvals/designation-approval/DesignationApproval')
);
const DepartmentApproval = lazy(
  () => import('pages/approvals/department-approval/DepartmentApproval')
);
const ShiftApproval = lazy(
  () => import('pages/approvals/shift-approval/ShiftApproval')
);
const HolidayApproval = lazy(
  () => import('pages/approvals/holiday-approval/HolidayApproval')
);
const MaterialApproval = lazy(
  () => import('pages/approvals/material-approval/MaterialApproval')
);
const VehicleTypeApproval = lazy(
  () => import('pages/approvals/vehicleType-approval/VehicleTypeApproval')
);
// const Dashboard = lazy(() => import('pages/dashboard/Dashboard'));
const FLyAshReport = lazy(() => import('pages/fly-ash-report/FLyAshReport'));
const CoalIronoreReport = lazy(
  () => import('pages/coal-iron-ore-report/CoalIronoreReport')
);
const CasualBreakApproval = lazy(
  () => import('pages/approvals/casualBreak-approval/CasualBreakApproval')
);
const OuterWorkingApproval = lazy(
  () => import('pages/approvals/outerWorking-approval/OuterWorkingApproval')
);
const ChallanApproval = lazy(
  () => import('pages/approvals/challan-approval/ChallanApproval')
);
const ManualPunchApproval = lazy(
  () => import('pages/approvals/manual-punch-approval/ManualPunchApproval')
);
export function SuspenseWrapper({ children }: { children: any }) {
  return <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>;
}

const routes: RouteObject[] = [
  {
    element: <AuthProvider />,
    errorElement: <GeneralError />,
    children: [
      {
        element: <App />,
        children: [
          {
            path: '/',
            element: (
              // <IntroWrapper>
              <Outlet />
              // </IntroWrapper>
            ),
            children: [
              {
                path: '/',
                errorElement: <GeneralError />,

                element: (
                  <MainLayoutProvider>
                    <MainLayout />
                  </MainLayoutProvider>
                ),
                children: [
                  {
                    index: true,
                    element: (
                      <SuspenseWrapper>
                        <HomePage />
                      </SuspenseWrapper>
                    )
                  },
                  // {
                  //   path: 'home',
                  //   element: <Dashboard />
                  // },
                  {
                    path: '/dashboard',
                    children: [
                      {
                        path: 'hrmsDashboard',
                        element: (
                          <Protected action="view" module={'HRMS Dashboard'}>
                            <SuspenseWrapper>
                              <HrmsDashboard />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'my-attendance',
                        element: (
                          <Protected action="view" module={'My Dashboard'}>
                            {/* <SuspenseWrapper> */} <Dashboard />
                            {/* </SuspenseWrapper> */}
                          </Protected>
                        )
                      },
                      // {
                      //   path: 'sales',
                      //   element: (
                      //     <Protected action="view" module={'All'}>
                      //       <SalesDashboard />
                      //     </Protected>
                      //   )
                      // },
                      {
                        path: 'flyAsh-report',
                        element: (
                          <Protected action="view" module={'FlyAsh Report'}>
                            <SuspenseWrapper>
                              <FLyAshReport />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'coalIronore-report',
                        element: (
                          <Protected
                            action="view"
                            module={'Coal-Iron Ore Report'}
                          >
                            <SuspenseWrapper>
                              <CoalIronoreReport />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      }
                    ]
                  },
                  {
                    path: '/payments',
                    children: paymentsRoutes
                  },
                  {
                    path: '/vendor',
                    children: vendorRoutes
                  },
                  {
                    path: '/vehicle',
                    children: vehicleRoutes
                  },
                  {
                    path: '/location',
                    children: [
                      {
                        path: 'branch',
                        element: (
                          <Protected action="view" module={'Branch'}>
                            <SuspenseWrapper>
                              <Branch />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'location',
                        element: (
                          <Protected action="view" module={'Location'}>
                            <SuspenseWrapper>
                              <Location />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'route',
                        element: (
                          <Protected action="view" module={'Route'}>
                            <SuspenseWrapper>
                              <Route />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      }
                    ]
                  },
                  {
                    path: '/customer',
                    children: [
                      {
                        index: true,
                        element: (
                          <Protected action="view" module={'Customers'}>
                            <SuspenseWrapper>
                              <CustomerList />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'detail/:id',
                        element: (
                          <Protected action="view" module={'Customers'}>
                            <SuspenseWrapper>
                              <ComingSoon />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'new',
                        element: (
                          <Protected action="maker" module={'Customers'}>
                            <SuspenseWrapper>
                              <CreateCustomer isUpdate={false} />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'update/:id',
                        element: (
                          <Protected action="edit" module={'Customers'}>
                            <SuspenseWrapper>
                              <CreateCustomer isUpdate={true} />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      }
                    ]
                  },
                  {
                    path: '/hrms',
                    children: hrmsRoutes
                  },
                  {
                    path: '/operation',
                    children: [
                      {
                        path: 'DO',
                        children: [
                          {
                            index: true,
                            element: (
                              <Protected action="view" module={'DO'}>
                                <SuspenseWrapper>
                                  <DoList />
                                </SuspenseWrapper>
                              </Protected>
                            )
                          },
                          {
                            path: 'new',
                            element: (
                              <Protected action="maker" module={'DO'}>
                                <SuspenseWrapper>
                                  <CreateDO isUpdate={false} />
                                </SuspenseWrapper>
                              </Protected>
                            )
                          },
                          {
                            path: 'update/:id',
                            element: (
                              <Protected action="edit" module={'DO'}>
                                <SuspenseWrapper>
                                  <CreateDO isUpdate={true} />
                                </SuspenseWrapper>
                              </Protected>
                            )
                          }
                        ]
                      },
                      {
                        path: 'PO',
                        children: [
                          {
                            index: true,
                            element: (
                              <Protected action="view" module={'PO'}>
                                <SuspenseWrapper>
                                  <PoList />
                                </SuspenseWrapper>
                              </Protected>
                            )
                          },
                          {
                            path: 'new',
                            element: (
                              <Protected action="maker" module={'PO'}>
                                <SuspenseWrapper>
                                  <CreatePO isUpdate={false} />
                                </SuspenseWrapper>
                              </Protected>
                            )
                          },
                          {
                            path: 'update/:id',
                            element: (
                              <Protected action="edit" module={'PO'}>
                                <SuspenseWrapper>
                                  <CreatePO isUpdate={true} />
                                </SuspenseWrapper>
                              </Protected>
                            )
                          }
                        ]
                      },
                      {
                        path: 'permit',
                        children: [
                          {
                            index: true,
                            element: (
                              <Protected action="view" module={'Permit'}>
                                <SuspenseWrapper>
                                  <PermitList />
                                </SuspenseWrapper>
                              </Protected>
                            )
                          },
                          {
                            path: 'new',
                            element: (
                              <Protected action="maker" module={'Permit'}>
                                <SuspenseWrapper>
                                  <CreatePermit isUpdate={false} />
                                </SuspenseWrapper>
                              </Protected>
                            )
                          },
                          {
                            path: 'update/:id',
                            element: (
                              <Protected action="edit" module={'Permit'}>
                                <SuspenseWrapper>
                                  <CreatePermit isUpdate={true} />
                                </SuspenseWrapper>
                              </Protected>
                            )
                          }
                        ]
                      }
                      // {
                      //   path: 'challan',
                      //   children: [
                      //     {
                      //       index: true,
                      //       element: <ChallanList />
                      //     },
                      //     {
                      //       path: 'new',
                      //       element: <CreateChallan isUpdate={false} />
                      //     },
                      //     {
                      //       path: 'update/:id',
                      //       element: <CreateChallan isUpdate={true} />
                      //     }
                      //   ]
                      // }
                    ]
                  },

                  // {
                  //   path: '/inventory',
                  //   children: [
                  //     {
                  //       path: 'Dashboard',
                  //       children: [
                  //         {
                  //           index: true,
                  //           element: (
                  //             <Protected action="view" module={'All'}>
                  //               <SuspenseWrapper>
                  //                 <InventoryDashboard />{' '}
                  //               </SuspenseWrapper>
                  //             </Protected>
                  //           )
                  //         }
                  //       ]
                  //     },
                  //     {
                  //       path: 'InventoryItems',
                  //       children: [
                  //         {
                  //           index: true,
                  //           element: (
                  //             <Protected action="view" module={'All'}>
                  //               <SuspenseWrapper>
                  //                 <InventoryItemsList />{' '}
                  //               </SuspenseWrapper>
                  //             </Protected>
                  //           )
                  //         }
                  //       ]
                  //     },
                  //     {
                  //       path: 'InventoryCategories',
                  //       children: [
                  //         {
                  //           index: true,
                  //           element: (
                  //             <Protected action="view" module={'All'}>
                  //               <SuspenseWrapper>
                  //                 <InventoryCategoriesList />{' '}
                  //               </SuspenseWrapper>
                  //             </Protected>
                  //           )
                  //         }
                  //       ]
                  //     },
                  //     {
                  //       path: 'InventoryReports',
                  //       children: [
                  //         {
                  //           index: true,
                  //           element: (
                  //             <Protected action="view" module={'All'}>
                  //               <SuspenseWrapper>
                  //                 <InventoryReportsList />{' '}
                  //               </SuspenseWrapper>
                  //             </Protected>
                  //           )
                  //         }
                  //       ]
                  //     }
                  //   ]
                  // },

                  {
                    path: '/trips',
                    children: [
                      {
                        path: 'running-trips',
                        element: (
                          <Protected action="view" module={'Running Trips'}>
                            <SuspenseWrapper>
                              <RunningTrip />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'breakdown-trips',
                        element: (
                          <Protected action="view" module={'Breakdown Trips'}>
                            <SuspenseWrapper>
                              <BreakdownTrips />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'completed-trips',
                        element: (
                          <Protected action="view" module={'Completed Trips'}>
                            <SuspenseWrapper>
                              <CompletedTrips />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      }
                    ]
                  },

                  {
                    path: '/check',
                    children: [
                      {
                        path: 'manual-punch',
                        element: (
                          <Protected action="checker" module={'Manual Punch'}>
                            <SuspenseWrapper>
                              <CheckManualPunch />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      }
                    ]
                  },

                  {
                    path: '/approvals',
                    children: [
                      {
                        path: 'vehicle-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Vehicle'}>
                            <SuspenseWrapper>
                              <VehicleApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'driver-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Driver'}>
                            <SuspenseWrapper>
                              <DriverApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'location-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Location'}>
                            <SuspenseWrapper>
                              <LocationApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'customer-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Customers'}>
                            <SuspenseWrapper>
                              <CustomerApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'employee-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Employee'}>
                            <SuspenseWrapper>
                              <EmployeeApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'fuelretailer-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Fuel Retailer'}>
                            <SuspenseWrapper>
                              <FuelRetailerApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'regular-approval/:tab',
                        element: (
                          <Protected
                            action="approver"
                            module={'Regular Vendor'}
                          >
                            <SuspenseWrapper>
                              <RegularApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'trucker-approval/:tab',
                        element: (
                          <Protected
                            action="approver"
                            module={'Trucker Vendor'}
                          >
                            <SuspenseWrapper>
                              <TruckerApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },

                      {
                        path: 'branch-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Branch'}>
                            <SuspenseWrapper>
                              <BranchApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'route-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Route'}>
                            <SuspenseWrapper>
                              <RouteApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },

                      {
                        path: 'leave-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Leave'}>
                            <SuspenseWrapper>
                              <LeaveApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'do-approval/:tab',
                        element: (
                          <Protected action="approver" module={'DO'}>
                            <SuspenseWrapper>
                              <DoApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'po-approval/:tab',
                        element: (
                          <Protected action="approver" module={'PO'}>
                            <SuspenseWrapper>
                              <PoApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'permit-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Permit'}>
                            <SuspenseWrapper>
                              <PermitApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },

                      {
                        path: 'designation-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Designation'}>
                            <SuspenseWrapper>
                              <DesignationApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'department-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Department'}>
                            <SuspenseWrapper>
                              <DepartmentApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'shift-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Designation'}>
                            <SuspenseWrapper>
                              <ShiftApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'holidays-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Holidays'}>
                            <SuspenseWrapper>
                              <HolidayApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'material-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Material'}>
                            <SuspenseWrapper>
                              <MaterialApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'vehicleType-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Vehicle Type'}>
                            <SuspenseWrapper>
                              <VehicleTypeApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'casualBreak-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Casual Break'}>
                            <SuspenseWrapper>
                              <CasualBreakApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'outerWorking-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Outer Working'}>
                            <SuspenseWrapper>
                              <OuterWorkingApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'challan-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Coal/Iron Ore'}>
                            <SuspenseWrapper>
                              <ChallanApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'manualPunch-approval/:tab',
                        element: (
                          <Protected action="approver" module={'Manual Punch'}>
                            <SuspenseWrapper>
                              <ManualPunchApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      },
                      {
                        path: 'latePunchin-approval/:tab',
                        element: (
                          <Protected
                            action="approver"
                            module={'Late Punch-in Employee'}
                          >
                            <SuspenseWrapper>
                              <EmployeeLatePunchinApproval />
                            </SuspenseWrapper>
                          </Protected>
                        )
                      }
                    ]
                  }
                ]
              },
              {
                path: '/',
                element: (
                  <MainLayoutProvider>
                    <SuspenseWrapper>
                      <SettingLayout />
                    </SuspenseWrapper>
                  </MainLayoutProvider>
                ),
                children: [
                  {
                    path: 'settings',
                    element: <SettingNav />
                  },
                  {
                    path: 'settings/:setting',
                    element: (
                      <SuspenseWrapper>
                        <Settings />
                      </SuspenseWrapper>
                    ),
                    errorElement: <GeneralError />
                  }
                ]
              },
              {
                path: 'autoLogout',
                element: <>Auto logout</>,
                errorElement: <GeneralError />,
                loader: autoLogoutLoader
              }
            ]
          }
        ]
      },
      {
        element: <App guestGuard={true} />,
        children: [
          {
            path: '/auth/',
            children: [
              {
                path: 'login',
                element: (
                  <SuspenseWrapper>
                    <CardSignIn />
                  </SuspenseWrapper>
                ),
                errorElement: <GeneralError />
              },
              {
                path: 'autoLogin',
                element: <>Auto login</>,
                errorElement: <GeneralError />,
                loader: autoLoginLoader
              }
            ]
          }
        ]
      }
    ]
  }
];

export const router = createBrowserRouter(routes, {
  basename: '/'
});

export default routes;
